import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Report';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $monitoring = ActionCreator.Async(MODULE, 'Monitoring', (payload) => {
  return async (dispatch) => {
    dispatch($processing($monitoring.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/monitoring`, payload)
      .then((response) => {
        dispatch($monitoring.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($monitoring.OPERATION)));
  };
});


export const $receivableSummary = ActionCreator.Async(MODULE, 'ReceivableSummary', (payload) => {
  return async (dispatch) => {
    dispatch($processing($receivableSummary.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/receivable/summary`, payload)
      .then((response) => {
        dispatch($receivableSummary.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($receivableSummary.OPERATION)));
  };
});

export const $payableSummary = ActionCreator.Async(MODULE, 'PayableSummary', (payload) => {
  return async (dispatch) => {
    dispatch($processing($payableSummary.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/payable/summary`, payload)
      .then((response) => {
        dispatch($payableSummary.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($payableSummary.OPERATION)));
  };
});

export const $outstanding = ActionCreator.Async(MODULE, 'Outstanding', (payload) => {
  return async (dispatch) => {
    dispatch($processing($outstanding.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/outstanding`, payload)
      .then((response) => {
        dispatch($outstanding.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($outstanding.OPERATION)));
  };
});

export const $receivableCustomer = ActionCreator.Async(MODULE, 'ReceivableCustomer', (payload) => {
  return async (dispatch) => {
    dispatch($processing($receivableCustomer.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/receivable/customer`, payload)
      .then((response) => {
        dispatch($receivableCustomer.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($receivableCustomer.OPERATION)));
  };
});

export const $agingCustomer = ActionCreator.Async(MODULE, 'AgingCustomer', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($agingCustomer.OPERATION));

    return await Rest.GET(`${API_URL}/finance/report/receivable/aging/${id}/customer`, payload)
      .then((response) => {
        dispatch($agingCustomer.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($agingCustomer.OPERATION)));
  };
});
